export const ACTIVE_TOURNAMENT = 'wc-26';
export const worldPopulation = 8000000000;

/** Game updates at or before this instant (Firestore `timestamp` ms) count toward group-stage scoring. */
export const GROUP_STAGE_SCORING_CUTOFF_MS = 1782694799000;

/**
 * MatchDay-based scoring configuration (WC26).
 *
 * These are the authoritative defaults seeded onto the `competitions/{ACTIVE_TOURNAMENT}`
 * document by the migration. The backend engine always reads the live values from that
 * document; these constants exist so the seed + client previews stay in sync.
 *
 * See `docs/matchday-scoring/` for the full model.
 */
/** Number of contiguous MatchDays (1..N). WC26 fixtures span MatchDays 1..34. */
export const MATCHDAY_COUNT = 34;
/**
 * Swapped roster order applies to MatchDays strictly greater than this value.
 * 27 = last Round of 16 MatchDay, so the swap takes effect from the quarter-finals (MD28+).
 */
export const SWAP_MATCHDAY = 27;
/**
 * First quarter-final kickoff (QF_1 in fixtures.json, MD28). The swap window closes before this instant.
 * 2026-07-09 20:00 UTC = 9pm UK (BST).
 */
export const SWAP_WINDOW_CLOSES_AT = new Date('2026-07-09T20:00:00Z');
/** Last MatchDay on which a user may reset their list back to 0 (must be <= SWAP_MATCHDAY). */
export const RESET_CUTOFF_MATCHDAY = 17;

/**
 * Maximum competing members for which the standings-over-time chart is offered.
 * Larger leagues (e.g. the Global League) are computationally and visually intractable.
 * Tunable threshold — raise once the chart is validated at larger sizes.
 */
export const MAX_CHART_LEAGUE_SIZE = 20;
